module.exports = __webpack_public_path__ + "img/owl.d9a50e42.svg";